import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"
}), 'StarSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/StarSharp.js
// module id = 6476
// module chunks = 2